import FieldSuggestions, {
  Suggestion,
} from 'components/field-suggestions/field-suggestions';
import FormField from 'components/form-field/form-field';
import React, { FunctionComponent, useMemo } from 'react';

type Props = {
  suggestions: string[];
};

export const BillingEmailField: FunctionComponent<Props> = ({
  suggestions: emailSuggestions,
}) => {
  const suggestions: Suggestion[] = useMemo(
    () =>
      emailSuggestions.map((email) => ({
        key: email,
        label: email,
        fields: { billingEmail: email },
      })),
    [emailSuggestions],
  );

  return (
    <FieldSuggestions
      label="Email de facturation"
      suggestions={suggestions}
      placeholder="Sélectionnez votre email de facturation..."
      required
    >
      <FormField
        type="email"
        name="billingEmail"
        label="Email personnalisé"
        required
      />
    </FieldSuggestions>
  );
};
